<template>
    <div class="log" :style="dynamicStyle" :title="infos">
        <span > {{leave.duration}} <!--{{leave.project_name}}-->- {{leave.user_name}}</span>
    </div>

</template>
<script>
    import {
        colorsEvent
    } from "../../settings.js";
    export default {
        name: "EventLeave",
        debug: false,
        props: ['leave','nbLeave','idToColor'],
        data() {
            return {
            }
        },
        computed: {
            dynamicStyle: function() {
                var percent = 12.3;
                if(this.nbLeave){
                    if(this.nbLeave > 0 && this.nbLeave <9){
                        percent = (100/this.nbLeave)-0.3; 
                    }    
                }
                var nbColors = colorsEvent.length;
                return {
                    background: colorsEvent[this.idToColor.indexOf(this.leave.user_id) % nbColors],
                    width: percent+'%',
                }
            },
            infos: function(){
                return this.leave.duration +" / "+ this.leave.client_name;
            }
        },
    }
</script>

<style scoped>
    .log {
        display: inline-block;
        margin-right: 0.3%;
        margin-top: 0.1em;
        padding: 0.1em;
        border: solid black 1px;
    }

    span {
        display: inline-block;
        margin: 0;
        padding: 0;
        width: 100%;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .log:hover {
        cursor: pointer;
    }
</style>